import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Internationalization } from '@syncfusion/ej2-base';
import { LoginService } from '../../../user/services/login.service';
import * as moment from 'moment';
import { MqttService, IMqttMessage } from 'ngx-mqtt';
import { Subscription } from 'rxjs';
declare const window: any;

const instance: Internationalization = new Internationalization();

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  host: { 'class': 'content'}
})
export class DashboardComponent implements OnInit {

  testMessage =
  `{
      id: 5,
      title: "Test title",
      data: [
        {
          name: "Test name",
          count: 65
        },
        {
          name: "Test name2",
          count: 465
        }
      ]
    }
  `;

  errors = [];

  myLifts = [];
  company = [];
  users = [];

  subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public loginService: LoginService,
    private mqttService: MqttService
  ) { }

  ngOnInit() {
    this.myLifts = this.route.snapshot.data.lifts.body;
    this.errors = this.route.snapshot.data.errors.body;
    this.company.push(this.route.snapshot.data.tariff);

    this.myLifts.forEach(lift => {
      let subscription = this.mqttService.observe('/module/' + String(lift.liftModuleCode) + '/#').subscribe((message: IMqttMessage) => {
        if (message.retain == true) {
          return;
        }

        if (message.topic == '/module/' + String(lift.liftModuleCode) + '/lift') {
          let liftData: any = message.payload.toString();
          liftData = JSON.parse(liftData);
          const obj = JSON.parse(liftData);
          const mode = obj.data.mode;

          if (mode == 2) {
            this.showErrorNotification(String(lift.liftModuleCode));
          }

          let liftToUpdate = this.myLifts.find(item => item.liftModuleCode == lift.liftModuleCode)
          let index = this.myLifts.indexOf(liftToUpdate);

          if (liftToUpdate.liftModuleStateData.data) {
            liftToUpdate.liftModuleStateData.data.mode = mode;
          } else {
            liftToUpdate.liftModuleStateData['data'] = {};
            liftToUpdate.liftModuleStateData.data['mode'] = mode;
          }

          this.myLifts[index] = liftToUpdate;
        }

        if (message.topic == '/module/' + String(lift.liftModuleCode) + '/disconnected') {
          console.log('disconnected');
          //this.showDisconnectNotification(String(lift.liftModuleCode));
          let liftToUpdate2 = this.myLifts.find(item => item.liftModuleCode == lift.liftModuleCode)
          let index2 = this.myLifts.indexOf(liftToUpdate2);

          liftToUpdate2.isConnected = false;
          this.myLifts[index2] = liftToUpdate2;
          
          const myClonedArray2 = [];
          this.myLifts.forEach(val => myClonedArray2.push(Object.assign({}, val)));
          this.myLifts = [];
          this.myLifts = myClonedArray2;

        }

        if (message.topic == '/module/' + String(lift.liftModuleCode) + '/connected') {
          console.log('connected');
          let liftToUpdate3 = this.myLifts.find(item => item.liftModuleCode == lift.liftModuleCode)
          let index3 = this.myLifts.indexOf(liftToUpdate3);

          liftToUpdate3.isConnected = true;
          this.myLifts[index3] = liftToUpdate3;

          const myClonedArray = [];
          this.myLifts.forEach(val => myClonedArray.push(Object.assign({}, val)));
          this.myLifts = [];
          this.myLifts = myClonedArray;
        }
      });

      this.subscriptions.push(subscription);
    });
    
  }

  openStat(id) {
    this.router.navigate([{ outlets: { modal: ['lift-state', id] } }]);
  }

  rowSelected(event) {
    console.log(event);
  }

  formatDate(date: string) {
    if (!date) {
      return '-';
    }
    const lastLogin = moment(date);
    return lastLogin.format('DD.MM.YYYY HH:mm');
  }

  showErrorNotification(moduleCode) {
    console.log("porucha");
    //alert('Výtah ' + moduleCode + 'se nachází v poruše');

    if (window.Notification && Notification.permission !== "denied") {
      Notification.requestPermission(function (status) {  // status is "granted", if accepted by user
        var n = new Notification('Výtah mimo provoz', {
          body: 'Výtah ' + moduleCode+ ' se nachází v poruše.',
          icon: '/assets/img/notif.jpg',
          requireInteraction: true // optional
        });
      });
    }
  }

  showDisconnectNotification(moduleCode) {
    if (window.Notification && Notification.permission !== "denied") {
      Notification.requestPermission(function (status) {  // status is "granted", if accepted by user
        var n = new Notification('Výtah odpojen', {
          body: 'Výtah ' + moduleCode + ' se odpojil a je offline.',
          icon: '/assets/img/notif.jpg',
          requireInteraction: true // optional
        });
      });
    }
  }

  public ngOnDestroy() {
    console.log("ondestroy");
    if (this.subscriptions.length > 0) { 
      this.subscriptions.forEach(sub => {
        sub.unsubscribe();
      });
    }
  }

}
